import { render } from "./SobreProjeto.vue?vue&type=template&id=3cc08fe9"
import script from "./SobreProjeto.vue?vue&type=script&lang=js"
export * from "./SobreProjeto.vue?vue&type=script&lang=js"

import "./SobreProjeto.vue?vue&type=style&index=0&id=3cc08fe9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__